// This script is used to filter products in a collection based on multiple filters.

// common functions for filters

// Updates the URL with the new filter parameters.
// const generateUrl = (urlPath) => {
//   const filterParams = getFilterParams().length > 0 ? getFilterParams() : null;
//   const subCategoryParams = getSubCategoryParams();
//   const searchParam = filterParams ? `?${filterParams}` : ``;
//   const newUrl = `${location.origin}${urlPath}${searchParam}`;
//   return newUrl;
// };
const generateUrl = (urlPath) => {
  let filterParams = getFilterParams().length > 0 ? getFilterParams() : null;

  // Encode each filter value inside the param string
  if (filterParams) {
    // Split & rebuild properly
    filterParams = filterParams
      .split("&")
      .map(param => {
        const [key, value] = param.split("=");
        return `${key}=${encodeURIComponent(value)}`;
      })
      .join("&");
  }

  const searchParam = filterParams ? `?${filterParams}` : ``;
  const newUrl = `${location.origin}${urlPath}${searchParam}`;
  
  return newUrl;
};


// Displays the loading state by adding the "loading-state" class and removing the "u-hide" class.
const showLoadingState = () => {
  document
    .querySelector(".collection-product-grid")
    ?.classList.add("loading-state");
  document.querySelector(".product-list-loading")?.classList.remove("u-hide");
};

// Removes all active filters from the collection filters.
const removeAllFilters = () => {
  document
    .querySelectorAll(
      `.advanced-collection-filters .filter-column .advanced-filters .advanced-filter.active-filter`
    )
    .forEach((filter) => {
      filter.classList.remove("active-filter");
    });
};

// Updates the filtered collection by fetching the new content from the server.
const updateFilteredCollection = async (url) => {
  try {
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const newDocument = parser.parseFromString(html, "text/html");
    const newCollection = newDocument.querySelector(
      ".product-list .wrapper:has(.collection-product-grid .product-grid)"
    );
    const newMobileFilters = newDocument.querySelector(
      ".advanced-collection-filters.view-mobile"
    );
    const newCollectionBanner = newDocument.querySelector(
      ".collection-top-banner"
    );
    if (newCollection) {
      document.querySelector(
        ".product-list .wrapper:has(.collection-product-grid .product-grid)"
      ).innerHTML = newCollection.innerHTML;
    }
    if (newMobileFilters) {
      document.querySelector(".advanced-collection-filters.view-mobile").innerHTML =
        newMobileFilters.innerHTML;
    }
    if (newCollectionBanner) {
      document.querySelector(".collection-top-banner").innerHTML =
        newCollectionBanner.innerHTML;
    }
    if (!newCollection && !newMobileFilters && !newCollectionBanner) {
      window.location = url;
    }
    CollectionPageFunctions(); // function from collection template
    document.body.style.overflow = "visible";
  } catch (error) {
    console.error("Error loading filtered collection:", error);
  }
};

// filter functions -- top filters
const updateFilterStatus = (e) => {
  document
    .querySelectorAll(".advanced-collection-filters .filter-column")
    .forEach((item) => {
      item != e.target.closest(".filter-column") &&
        item.classList.remove("active");
    });
  e.target.closest(".filter-column").classList.toggle("active");
};

// Displays the loading state by removing the "u-hide" class.
const getFilterParams = () => {
  const activeFilters = document.querySelectorAll(
    ".advanced-collection-filters.view-mobile .advanced-filter.active-filter"
  );
  const filterParams = [...activeFilters]
    .map((filter) => {
      const param = filter.getAttribute("data-filter-param");
      const value = filter.getAttribute("data-handle");
      return param && value ? `${param}=${value}` : null;
    })
    .filter(Boolean)
    .join("&");
  return filterParams;
};

// Adds event listeners to all filter elements.
const filterItemsClickEvent = (e) => {
  const filter = e.target;
  const dataHandle = filter.getAttribute("data-handle");
  document
    .querySelectorAll(
      `.filter-column .advanced-filters [data-handle='${dataHandle}']`
    )
    .forEach((filterItem) => {
      filterItem.classList.toggle("active-filter");
    });
  document.body.style.overflow = "hidden";
  showLoadingState();
  updateFilteredCollection(generateUrl(getSubCategoryParams().href));
  updateUrl(generateUrl(location.pathname)); // this function is from store.js
};

// remove single filter
const removeFilter = (e) => {
  e.preventDefault();
  const data_handle = e.target
    .closest(".active-filters-list .active-filter-label")
    .getAttribute("data-handle");
  const correspondingFilter = document.querySelector(
    `.advanced-collection-filters.view-desktop .filter-column .advanced-filters .advanced-filter[data-handle='${data_handle}']`
  );
  correspondingFilter.click();
  correspondingFilter.closest(".filter-column").classList.remove("active");
};

const closeMobileFilter = (e) => {
  document.querySelector(".collection-filters.view-mobile .title").click();
};

// subcategory functions -- sidemenu filters
const updateSubcategoryActiveState = (subCategory) => {
  document
    .querySelectorAll(
      ".sidebar-navigation .sub-categories .sub-category.parent--current"
    )
    .forEach((item) => {
      item.classList.remove("parent--current");
    });
  subCategory.parentElement.classList.add("parent--current");
};
const getSubCategoryParams = () => {
  const category = document.querySelector(
    ".sidebar-navigation .sub-categories .sub-category.parent--current a"
  );
  return {
    param: `subCategory=${category.getAttribute("data-category")}`,
    href: category.getAttribute("href"),
  };
};

// const subCategoryClickEvent = () => {
//   const subCategoryList = document.querySelectorAll(
//     ".sidebar-navigation .sub-categories .sub-category a"
//   );
//   subCategoryList.forEach((subCategory) => {
//     subCategory.addEventListener("click", (e) => {
//       e.preventDefault();
//       if (e.target.parentElement.classList.contains("parent--current")) {
//         return;
//       }
//       document.body.style.overflow = "hidden";
//       removeAllFilters();
//       updateSubcategoryActiveState(subCategory);
//       showLoadingState();
//       updateFilteredCollection(generateUrl(getSubCategoryParams().href));
//       updateUrl(generateUrl(location.pathname)); // this function is from store.js
//     });
//   });
// };
// subCategoryClickEvent();

// clear filters functions
const clearAllFilters = (e) => {
  e.preventDefault();
  document.body.style.overflow = "hidden";
  removeAllFilters();
  showLoadingState();
  updateFilteredCollection(generateUrl(getSubCategoryParams().href));
  updateUrl(generateUrl(location.pathname)); // this function is from store.js
};

// special meganav functions
const getItemData = (item) => {
  return {
    title: item.textContent.trim(),
    handle: item.dataset["handle"],
    url: item.getAttribute("href"),
  };
};

const megaNavMenuItems = document.querySelectorAll(
  ".meganav .meganav-menu__links .meganav-menu__item a"
);
// const megaNavMenuItems = document.querySelectorAll(
//   ".meganav.meganav--desktop .meganav-menu__links .meganav-menu__item a"
// );
megaNavMenuItems.forEach((item) => {
  item.addEventListener("click", (e) => {
    const clickedItem = e.target;
    const parentNodeData = getItemData(
      clickedItem.closest(".meganav-menu").querySelector(".meganav-heading a")
    );
    const allItems = clickedItem
      .closest(".meganav-menu__links")
      .querySelectorAll(".meganav-menu__item a");
    const itemsArray = [];
    const seen = new Set();
    allItems.forEach((item) => {
      const data = getItemData(item);
      const key = JSON.stringify(data);
      if (!seen.has(key)) {
        seen.add(key);
        itemsArray.push({ data });
      }
    });

    localStorage.setItem(
      "meganav-menu-items",
      JSON.stringify({
        parentMenuData: itemsArray,
        clickedItem: getItemData(clickedItem),
        parentNodeData: parentNodeData,
        isSideMenuApplied: false,
      })
    );
  });
});
// special meganav functions

// this is global function and will run if it is not a collection page

const clearLocalStorageForMegaMenu = (itemArray) => {
  itemArray.forEach((item) => {
    item.addEventListener("click", () => {
      localStorage.removeItem("meganav-menu-items");
    });
  });
};
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".template-collection")) {
    const itemArray = document.querySelectorAll(
      "a[href*='/collections/']:not(.meganav a[href*='/collections/'])"
    );
    clearLocalStorageForMegaMenu(itemArray);
  }
  const megaMenuItems = document.querySelectorAll(
    ".meganav a:not(.meganav .meganav-menu__links a"
  );
  // const megaMenuItems = document.querySelectorAll(
  //   ".meganav.meganav--desktop a:not(.meganav.meganav--desktop .meganav-menu__links a"
  // );
  clearLocalStorageForMegaMenu(megaMenuItems);
});
// this is global function and will run if it is not a collection page
